import React, { Component } from 'react'
export default class Sidebar extends Component {
  render() {
    return (
      <div>
        <div>
          <nav href="#navbar" className="js-davidvallejo-nav-toggle davidvallejo-nav-toggle" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar"><i /></nav>
          <aside id="davidvallejo-aside" className="border js-fullheight">
            <div className="text-center">
            <a href="index.html" data-nav-section="home">
              <div className="author-img" href="#home" data-nav-section="home" style={{backgroundImage: 'url(images/davidvallejo1.png)'}} />
              </a>
              <h1 id="davidvallejo-logo"><a href="index.html">David Vallejo</a></h1>
              <div id="contact" class="contact row">
              <h6 className="contact"><i id="contactIcon" className="icon-paperplane"></i> davidevallejo@gmail.com </h6>
              <h6 className="contact"><i id="contactIcon" className="icon-phone3"></i> (813) 326-3626 </h6>
              </div>
            </div>
            <nav id="davidvallejo-main-menu" role="navigation" className="navbar">
              <div id="navbar" className="collapse">
                <ul>
                  <li className="active"><a href="#home" data-nav-section="home">Intro</a></li>
                  <li><a href="#about" data-nav-section="about">About Me</a></li>
                  {/*<li><a href="#" data-nav-section="projects">Projects</a></li>
                  <li><a href="#" data-nav-section="blog">Blog</a></li>*/}
                  <li><a href="#projects" data-nav-section="projects">Projects</a></li>
                  <li><a href="#resources" data-nav-section="resources">Resources</a></li>
                  <li><a href="#timeline" data-nav-section="timeline">Timeline</a></li>
                </ul>
              </div>
            </nav>
            <nav id="davidvallejo-main-menu">
              <ul>
                <li><a href="#" target="_blank" rel="noopener noreferrer"><button type="button" class="btn  btn-circle btn-lg"><i class="icon-facebook2"></i></button>
                </a></li>
                <li><a href="#" target="_blank" rel="noopener noreferrer"><button type="button" class="btn  btn-circle btn-lg"><i class="icon-twitter2"></i></button>
                </a></li>
                <li><a href="#" target="_blank" rel="noopener noreferrer"><button type="button" class="btn  btn-circle btn-lg"><i class="icon-instagram"></i></button>
                </a></li>
                <li><a href="#" target="_blank" rel="noopener noreferrer"><button type="button" class="btn  btn-circle btn-lg"><i class="icon-linkedin2"></i></button>
                </a></li>
                <li><a href="#" target="_blank" rel="noopener noreferrer"><button type="button" class="btn  btn-circle btn-lg"><i class="icon-github"></i></button>
                </a></li>
                <li><a href="#" target="_blank" rel="noopener noreferrer"><button type="button" class="btn  btn-circle btn-lg"><i class="icon-whatsapp"></i></button>
                </a></li>
              </ul>
            </nav>
          </aside>
        </div>
      </div>
    )
  }
}
